import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getChatRooms = params => {
  return ApiService.query(
    `chat/rooms/${params.chatRoomType}/me?${stringify(params)}`,
  );
};

export const getChatRoomsNewMessages = params => {
  return ApiService.query(`chat/rooms/newMessages`, {
    isLoading: false,
  });
};

export const getChatRoom = params => {
  return ApiService.query(`chat/room/${params.uuid}`);
};
export const getChatRoomById = params => {
  return ApiService.query(`chat/room/id/${params.chatRoomId}`);
};

export const getChatRoomWithStore = params => {
  return ApiService.query(
    `chat/rooms/${params.chatRoomType}/store/${params.storeId}`,
  );
};

export const getChatRoomWithMember = params => {
  return ApiService.query(
    `chat/rooms/${params.chatRoomType}/member/${params.memberId}`,
  );
};
export const createChatRoom = params => {
  return ApiService.post(`chat/room`, params);
};

export const syncChatRoom = params => {
  return ApiService.post(`chat/room/sync/${params.uuid}`);
};

export const getChatMessagesByMessageIdx = params => {
  return ApiService.query(
    `chat/messages/${params.uuid}?startIdx=${params.startIdx}&size=${params.size}`,
  );
};

export const uploadFile = params => {
  const payload = new FormData();
  payload.append('file', params.file);
  return ApiService.post(`chat/file/${params.uuid}`, payload);
};

export const modifyScreenActived = params => {
  return ApiService.put(`chat/member/screenActived`, params);
};

export const modifyScreenActivedAll = params => {
  return ApiService.put(`chat/member/screenActived/all`, params);
};

export const resetChatCache = params => {
  return ApiService.put(`chat/reset`, params);
};

export const getChatMessagesBySystemType = params => {
  return ApiService.query(
    `chat/rooms/SYSTEM/messages/search?${stringify(params)}`,
  );
};
export const getChatMessageBySystemType = params => {
  return ApiService.query(
    `chat/rooms/${params.chatRoomType}/${params.chatRoomId}/message`,
  );
};
export const getChatMessages = params => {
  return ApiService.query(
    `chat/rooms/${params.chatRoomType}/${params.chatRoomId}/messages?page=${params.page}&size=${params.size}`,
  );
};
export const sendChatMessageManual = params => {
  return ApiService.post(`chat/message/${params.uuid}/send`, params);
};
export const downloadExcelChatMessagesBySystemType = params => {
  return ApiService.file(
    `chat/rooms/SYSTEM/messages/search/excel?${stringify(params)}`,
  );
};
export const sendEstimate = params => {
  const payload = new FormData();
  for (const key in params) {
    payload.append(key, params[key]);
  }
  return ApiService.post(`chat/message/estimate`, payload);
};

// 사전예약 채팅내용 전송
export const sendBooking = params => {
  return ApiService.post(`chat/message/booking`, params);
};

// 사전예약 채팅내용 전송
export const sendInternetCommerce = params => {
  return ApiService.post(`chat/message/internetCommerce`, params);
};

// 견적요청서 선택한 매장에 전송
export const sendEstimateStores = params => {
  console.log('sendEstimateStores');
  return ApiService.post(`chat/message/estimate/stores`, params);
};

// 메시지 읽음 idx
export const getChatWatch = params => {
  return ApiService.query(`chat/watch?${stringify(params)}`, {
    isLoading: false,
  });
};

// 채팅방 차단 (사장님)
export const setChatBlock = params => {
  return ApiService.post(`chat/room/block`, params, {
    isLoading: false,
  });
};

// 채팅리스트타입 변경 (chat_list_type = I)
export const setChatListType = params => {
  return ApiService.post(`chat/room/chatListType`, params, {
    isLoading: false,
  });
};

export const sendMobileRequest = params => {
  return ApiService.post(`chat/message/mobileRequest`, params);
};

export const getChatRoomCheckLimit = params => {
  return ApiService.query(`chat/room/checkLimit?${stringify(params)}`);
};
// 채팅 신고 (사용자)
export const setChatReport = params => {
  return ApiService.post(`chat/report`, params);
};
// 시스템 공지
export const chatMessageNotice = params => {
  return ApiService.post(`chat/message/notice`, params);
};

// 1:1문의 읽지않은 개수
export const getCheckNewReply = params => {
  return ApiService.query(`chat/message/checkNewReply?${stringify(params)}`);
};

// 프로모션 채팅방 생성
export const chatRoomPromotionMessage = params => {
  return ApiService.post(`chat/message/promotion`, params);
};
